const mapTariffs = (tariff) => ({ text: tariff.name, value: tariff.permanentId });

export { mapTariffs };
